module.exports = __webpack_public_path__ + "img/socks-or-barefoot.266003b9.svg";